// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"82df85dd","259":"7b2ebd9b","494":"78a2ca84","553":"2f7432e8","794":"29b1054b","961":"b6ffa349"}[chunkId] + ".chunk.js";
};